import { render, staticRenderFns } from "./IntelipostComponent.vue?vue&type=template&id=6f4eaec4"
import script from "./IntelipostComponent.vue?vue&type=script&lang=js"
export * from "./IntelipostComponent.vue?vue&type=script&lang=js"
import style0 from "./IntelipostComponent.vue?vue&type=style&index=0&id=6f4eaec4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports